import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Custom hook for polling an API every X milliseconds.
 * @param baseUrl - API Base url
 * @param endpoint - API endpoint to fetch
 * @param interval - Polling interval in milliseconds (default: 1000ms)
 */
const usePolling = (axiosConfig, interval = 1000) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios(axiosConfig);
        if (isMounted) {
          setData(response.data);
          setIsLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.response?.data?.message || "Error fetching data");
          setIsLoading(false);
        }
      }
    };

    // Initial fetch
    fetchData();

    // Set up polling
    const intervalId = setInterval(fetchData, interval);

    return () => {
      isMounted = false;
      clearInterval(intervalId); // Cleanup interval on unmount
    };
  }, [axiosConfig?.url, interval]);

  return { data, isLoading, error };
};

export default usePolling;